module.exports = __webpack_public_path__ + "img/appIndex.da1b92ff.png";